import { type StartAutomationStep } from 'pages/AutomationEngine/dialogs/ActionWizard/subsections/actionSectionTypes';
import { getValueOrDeleted } from './action-helpers';
import { TFunction } from 'react-i18next';
import DraggableStepCard, { DraggableStepCardProps } from '../../DraggableStepCard';

export const content = ({ step }: { step: StartAutomationStep }) =>
  step.description;

export const getDescription = ({
  step: { details },
  t,
}: {
  step: StartAutomationStep;
  t: TFunction;
}) => {
  const { recordSource, relationshipFields, automationVariable, automations } =
    details;

  const automationsToStart = automations
    .map(
      ({ label, deleted }) => `${label}${deleted ? ` [${t('Deleted')}]` : ''}`
    )
    .sort((a, b) => {
      return a.localeCompare(b, 'en', { sensitivity: 'base' });
    })
    .join(', ');

  if (recordSource === 'automation_variable' && automationVariable) {
    const variableName = `${automationVariable.label}${automationVariable.deleted ? ` [${t('Deleted')}]` : ''}`;
    return t(
      `{{actionType}} '{{automationsToStart}}' on Variable '{{variableName}}'`,
      { automationsToStart, variableName, actionType: t('Start') }
    );
  }

  if (recordSource === 'related_object_field') {
    const relationshipFieldNames = getValueOrDeleted(
      relationshipFields
        .map(
          ({ label, deleted }) =>
            `${label}${deleted ? ` [${t('Deleted')}]` : ''}`
        )
        .sort((a, b) => {
          return a.localeCompare(b, 'en', { sensitivity: 'base' });
        })
        .join(', '),
      t
    );

    return t(
      `{{actionType}} '{{automationsToStart}}' on '{{relationshipFieldNames}}'`,
      { automationsToStart, relationshipFieldNames, actionType: t('Start') }
    );
  }

  return t(`{{actionType}} '{{automationsToStart}}'`, {
    automationsToStart,
    actionType: t('Start'),
  });
};

export default function StartAutomationCard({
  step,
  ...others
}: {
  step: StartAutomationStep;
} & DraggableStepCardProps) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
